import {BaseMuixFilterController} from "../../../components/muix-data-grid/controllers/BaseMuixFilterController.ts";
import {action, computed, makeObservable} from "mobx";
import {AiChangeChart, convertToChart} from "../../../services/classes/CategorizationHelpers.ts";
import {BagStore} from "../../../stores/BagStore.tsx";
import ProfileStore from "../../../stores/ProfileStore.tsx";
import {MatReviewLevelStatisticsTreeSerializer} from "../../../services/classes/MaterializedClasses.ts";
import {GRPageController} from "./GRPageController.ts";

export class GRFilterController extends BaseMuixFilterController {
    constructor(
        private controller: GRPageController,
        private profile: ProfileStore,
        protected bagStore: BagStore,
    ) {
        super(controller.tableController);
        makeObservable(this, {
            selectNextCategoryDown: action,
            navigateToLevel: action,
            selectedCategoryLabel: computed,
            canSelectLevelDeeper: computed,
            hasRemainingSelectionLevels: computed,
            currentSelectionStats: computed,
            selectionCharts: computed,
        });
    }

    selectNextCategoryDown(selectedCategory: string) {
        this.setSelectedCategory([...this.selectedCategory, selectedCategory])
    }

    navigateToLevel(level: number) {
        this.setSelectedCategory(this.selectedCategory.slice(0, level));
    }

    get selectedCategoryLabel(): string | undefined {
        if (this.selectedCategory.length > 0) {
            return this.selectedCategory[this.selectedCategory.length - 1]
        }
        return undefined;
    }

    get canSelectLevelDeeper(): boolean {
        return true;
        // return this.bagStore.taxonomy_size > this.selectedLevel;
    }

    get hasRemainingSelectionLevels(): boolean {
        if (this.selectedLevel >= this.bagStore.taxonomy_size) {
            return false
        }
        // noinspection RedundantIfStatementJS
        if (this.selectedLevel >= 1 && !this.selectedCategoryLabel) {
            // Do not allow to go deeper in uncategorized
            return false;
        }
        return true;
    }

    get currentSelectionStats(): undefined | MatReviewLevelStatisticsTreeSerializer[] {
        if (!this.hasRemainingSelectionLevels) return undefined;
        if (!this.controller._selectedStats) return undefined;
        return this.controller._selectedStats[this.controller._selectedStats.length - 1].children;
    }

    get selectionCharts(): { data: AiChangeChart[], max: number } | undefined {
        if (!this.canSelectLevelDeeper) return undefined;
        const d = this.currentSelectionStats;
        if (!d) return undefined;
        // Note that for GR we don't need old values since we don't want to show AI categorization performance
        const data = convertToChart(d.filter(d =>
                d.values['post_parts']
            ), this.profile.currencySymbol
        ).map(d => ({
            ...d,
            values: d.values.filter(v => v.dataCls === 'new')
        }));
        const COL_WIDTH = 6 / 9 // Show as width col=6, while the whole viz goes to col=9
        const max = Math.max(...data.map(D => Math.max(...D.values.map(v => v.value)))) / COL_WIDTH;
        return {data, max}
    }
}